import { type FunctionComponent } from 'react';
import { ACCOUNT_PROJECTS_DETAILS, ACCOUNT_PROJECTS_LINK } from '../../../constants/links';
import { type ProjectSuccessActions } from '../../../constants/project/general';
import { generatePath } from '../../../utils/routing/route.utils';
import { StyledLink } from '../../common-components/link/styled-link.component';

type ProjectFragment = { id: number; name: string; isLocked?: boolean };
const actionMessageMap = {
	COPY: {
		message: 'Copied to your projects!',
		appliedAction: 'Copied'
	},
	MOVE: {
		message: 'Moved to your projects!',
		appliedAction: 'Moved'
	},
	SAVE: {
		message: 'Your projects have been updated!',
		appliedAction: 'Saved'
	},
	ATTACH: {
		message: 'Your projects have been updated!',
		appliedAction: 'Attached'
	}
};

export type SavetoProjectSuccessBannerProps = {
	action: ProjectSuccessActions;
	project?: ProjectFragment;
};

export const SaveToProjectSuccessBanner: FunctionComponent<SavetoProjectSuccessBannerProps> = ({ action, project }) => {
	const link = project ? generatePath(ACCOUNT_PROJECTS_DETAILS, { projectId: project.id }) : ACCOUNT_PROJECTS_LINK;

	return (
		<div>
			<div className="b mb2">
				{project ? `${actionMessageMap[action].appliedAction} to ${project.name}!` : `${actionMessageMap[action].message}`}
			</div>
			<StyledLink url={link}>{project ? 'Go to Project' : 'Go to My Projects'}</StyledLink>
		</div>
	);
};
